import React from 'react';
import { Button, Space } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

export const ExportsButton = () => {
    const navigate = useNavigate();
    const openExports = () => {
        navigate('create');
    };

    return (
        <Space>
            <Button
                onClick={openExports}
                icon={<DownloadOutlined />}
                type={'default'}
            >
                Выгрузить в XLSX
            </Button>
        </Space>
    );
};
